import { render, staticRenderFns } from "./ForgotPasswordSent.pug?vue&type=template&id=9a366602&scoped=true&lang=pug&"
import script from "./ForgotPasswordSent.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordSent.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordSent.scss?vue&type=style&index=0&id=9a366602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a366602",
  null
  
)

export default component.exports